import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {
  getGroupIdentities,
  editIdentityGroupStatus
} from '../../actions/Identity';
import { sendLogin } from '../../auth/Auth';
import ReviewRefundPopup from './ReviewRefundPopup';
import ValidationText from '../atoms/ValidationText';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    padding: 15,
    overflow: 'auto',
    outline: 'none',
    fontSize: 12,
    lineHeight: '16px',
    color: '#333333',
    borderRadius: 4
  },
  title: {
    background: '#673ab7',
    color: '#ffffff',
    margin: '-15px -15px 15px -15px',
    padding: '15px',
    textAlign: 'center',
    fontSize: '16px'
  },
  row: {
    display: 'flex',
    marginBottom: '15px'
  },
  titleContent: {
    marginLeft: '20px',
    marginRight: '80px',
    lineHeight: '28px',
    paddingTop: '8px'
  },
  document: {
    width: '90%',
    margin: '5px'
  },
  btnCloseDiv: {
    textAlign: 'center'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold',
    width: '100%',
    '&:disabled': {
      color: '#fff',
      backgroundColor: '#673ab7'
    }
  },
  btnx: {
    position: 'absolute',
    top: '12px',
    right: '6px',
    minWidth: '12px',
    color: '#000000'
  },
  iconButton: {
    width: '12px',
    height: '12px'
  },
  dataContent: {
    paddingTop: '13px'
  },
  input: {
    lineHeight: '28px',
    marginBottom: '5px',
    width: '100px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getGroupIdentities, editIdentityGroupStatus },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openApprovalProgress', 'updateOpenApprovalProgress', false),
  withState('openReviewRefundPopup', 'setOpentReviewRefundPopup', false),
  withState('checkSubmit', 'setCheckSubmit', true),
  withState('inputAmountError', 'setInputAmountError', '必須項目です。'),
  withState('inputData', 'setInputData', null),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    openReviewRefundPopup,
    setOpentReviewRefundPopup,
    setOpenRefundPopup,
    setUpdateOpenRefundPopup,
    inputData,
    merchantPaymentId,
    paymentType,
    setInputData,
    setInputAmountError,
    checkSubmit,
    setCheckSubmit,
    inputAmountError,
    gochiBillNo,
    gochiBillId,
    paymentId,
    updateCheckRefund,
    chargeAmount = null
  }) => {
    const closeAction = () => {
      setOpenRefundPopup(false);
    };

    const validInput = value => {
      setCheckSubmit(false);
      if (value === '' || value === 0) {
        setInputAmountError('必須項目です。');
        setCheckSubmit(true);
        return 1;
      }
      if (value > chargeAmount) {
        setInputAmountError('返金金額を決済金額以内でご入力ください。');
        setCheckSubmit(true);
        return 1;
      }
      setInputAmountError('');
      return 0;
    };

    const RefundOpenAction = () => {
      setOpentReviewRefundPopup(true);
    };

    return (
      <div className={classes.root}>
        <Button className={classes.btnx} onClick={closeAction} color="primary">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.svg`}
            alt="close"
            className={classes.iconButton}
          />
        </Button>
        <div className={classes.title}>一部返金</div>
        <div className={classes.row}>
          <div className={classes.titleContent}>決済金額</div>
          <div className={classes.dataContent}>{`{ ${chargeAmount} } 円`}</div>
        </div>
        <div className={classes.row}>
          <div className={classes.titleContent}>返金金額</div>
          <div>
            <input
              type="number"
              placeholder=""
              min="0"
              max={chargeAmount}
              className={classes.input}
              onChange={event => setInputData(event.target.value)}
              onBlur={event => validInput(Number(event.target.value))}
            />
            <span>&nbsp;円</span>
            <ValidationText message={inputAmountError} />
          </div>
        </div>
        <div className={classes.btnCloseDiv}>
          <Button
            color="primary"
            variant="contained"
            onClick={RefundOpenAction}
            disabled={checkSubmit}
            className={classes.btnClose}
          >
            返金
          </Button>
        </div>
        <Modal open={openReviewRefundPopup}>
          <ReviewRefundPopup
            setOpentReviewRefundPopup={setOpentReviewRefundPopup}
            setOpenRefundPopup={setOpenRefundPopup}
            gochiBillIdData={gochiBillId}
            paymentIdData={paymentId}
            merPaymentId={merchantPaymentId}
            gochiBillNoo={gochiBillNo}
            setUpdateOpenRefundPopup={setUpdateOpenRefundPopup}
            updateCheckRefund={updateCheckRefund}
            paymentType={paymentType}
            chargeAmount={inputData}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
